import { applicationId } from "expo-application";

import { API_URLS, isWeb } from "@stepapp/core";

export const TEST_OR_STAGING =
  (isWeb && window?.location?.href?.includes?.("dev")) ||
  applicationId?.includes("beta") ||
  __DEV__;

enum APP_URLS {
  Production = "https://app.stepapp.pl",
  Staging = "https://dev.stepapp.pl",
}

export const APP_URL = TEST_OR_STAGING ? APP_URLS.Staging : APP_URLS.Production;

const getBaseBackendUrl = () => (TEST_OR_STAGING ? API_URLS.Staging : API_URLS.Production);

export const getApiUrl = () => `https://${getBaseBackendUrl()}/graphql/`;
export const getWsUrl = () => `wss://${getBaseBackendUrl()}/ws`;
